module.exports = __webpack_public_path__ + "img/img4.2e3a5e24.jpg";